export const UPDATE_CAMERAS = "DEVICES::UPDATE_CAMERAS";
export const UPDATE_REMOTE_CAMERAS = "DEVICES::UPDATE_REMOTE_CAMERAS";

export const SET_MICROPHONES = "DEVICES::SET_MICROPHONES";
export const UPDATE_MICROPHONES = "DEVICES::UPDATE_MICROPHONES";
export const UPDATE_REMOTE_MICROPHONES = "DEVICES::UPDATE_REMOTE_MICROPHONES";

export const UPDATE_SPEAKERS = "DEVICES::UPDATE_SPEAKERS";
export const UPDATE_REMOTE_SPEAKER = "DEVICES::UPDATE_REMOTE_SPEAKER";

export const DISABLE_CAMERA = "DEVICES::DISABLE_CAMERA";
export const DISABLE_CAMERA_SUCCEEDED = "DEVICES::DISABLE_CAMERA_SUCCEEDED";
export const DISABLE_CAMERA_FAILED = "DEVICES::DISABLE_CAMERA_FAILED";

export const DISABLE_MICROPHONE = "DEVICES::DISABLE_MICROPHONE";
export const DISABLE_MICROPHONE_SUCCEEDED =
  "DEVICES::DISABLE_MICROPHONE_SUCCEEDED";
export const DISABLE_MICROPHONE_FAILED = "DEVICES::DISABLE_MICROPHONE_FAILED";

export const DISABLE_SPEAKER = "DEVICES::DISABLE_SPEAKER";
export const DISABLE_SPEAKER_SUCCEEDED = "DEVICES::DISABLE_SPEAKER_SUCCEEDED";
export const DISABLE_SPEAKER_FAILED = "DEVICES::DISABLE_SPEAKER_FAILED";

export const ENABLE_CAMERA = "DEVICES::ENABLE_CAMERA";
export const ENABLE_MICROPHONE = "DEVICES::ENABLE_MICROPHONE";
export const ENABLE_SPEAKER = "DEVICES::ENABLE_SPEAKER";

export const CAMERA_TURN_ON = "DEVICES::CAMERA_TURN_ON";
export const CAMERA_TURN_ON_SUCCEEDED = "DEVICES::CAMERA_TURN_ON_SUCCEEDED";
export const CAMERA_TURN_ON_FAILED = "DEVICES::CAMERA_TURN_ON_FAILED";

export const CAMERA_TURN_OFF = "DEVICES::CAMERA_TURN_OFF";
export const CAMERA_TURN_OFF_SUCCEEDED = "DEVICES::CAMERA_TURN_OFF_SUCCEEDED";
export const CAMERA_TURN_OFF_FAILED = "DEVICES::CAMERA_TURN_OFF_FAILED";

export const CYCLE_CAMERA = "DEVICES::CYCLE_CAMERA";
export const CYCLE_CAMERA_SUCCEEDED = "DEVICES::CYCLE_CAMERA_SUCCEEDED";
export const CYCLE_CAMERA_FAILED = "DEVICES::CYCLE_CAMERA_FAILED";

export const MICROPHONE_TURN_ON = "DEVICES::MICROPHONE_TURN_ON";
export const MICROPHONE_TURN_ON_SUCCEEDED =
  "DEVICES::MICROPHONE_TURN_ON_SUCCEEDED";
export const MICROPHONE_TURN_ON_FAILED = "DEVICES::MICROPHONE_TURN_ON_FAILED";

export const MICROPHONE_TURN_OFF = "DEVICES::MICROPHONE_TURN_OFF";
export const MICROPHONE_TURN_OFF_SUCCEEDED =
  "DEVICES::MICROPHONE_TURN_OFF_SUCCEEDED";
export const MICROPHONE_TURN_OFF_FAILED = "DEVICES::MICROPHONE_TURN_OFF_FAILED";

export const SPEAKER_TURN_ON = "DEVICES::SPEAKER_TURN_ON";
export const SPEAKER_TURN_ON_SUCCEEDED = "DEVICES::SPEAKER_TURN_ON_SUCCEEDED";
export const SPEAKER_TURN_ON_FAILED = "DEVICES::SPEAKER_TURN_ON_FAILED";

export const SPEAKER_TURN_OFF = "DEVICES::SPEAKER_TURN_OFF";
export const SPEAKER_TURN_OFF_SUCCEEDED = "DEVICES::SPEAKER_TURN_OFF_SUCCEEDED";
export const SPEAKER_TURN_OFF_FAILED = "DEVICES::SPEAKER_TURN_OFF_FAILED";

export const CAMERAS_CHANGES_SUBSCRIBE = "DEVICES::CAMERAS_CHANGES_SUBSCRIBE";
export const CAMERAS_CHANGES_SUBSCRIBE_SUCCEEDED =
  "DEVICES::CAMERAS_CHANGES_SUBSCRIBE_SUCCEEDED";
export const CAMERAS_CHANGES_SUBSCRIBE_FAILED =
  "DEVICES::CAMERAS_CHANGES_SUBSCRIBE_FAILED";

export const CAMERAS_CHANGES_UNSUBSCRIBE =
  "DEVICES::CAMERAS_CHANGES_UNSUBSCRIBE";
export const CAMERAS_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "DEVICES::CAMERAS_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const CAMERAS_CHANGES_UNSUBSCRIBE_FAILED =
  "DEVICES::CAMERAS_CHANGES_UNSUBSCRIBE_FAILED";

export const REMOTE_CAMERAS_CHANGES_SUBSCRIBE =
  "DEVICES::REMOTE_CAMERAS_CHANGES_SUBSCRIBE";
export const REMOTE_CAMERAS_CHANGES_SUBSCRIBE_SUCCEEDED =
  "DEVICES::REMOTE_CAMERAS_CHANGES_SUBSCRIBE_SUCCEEDED";
export const REMOTE_CAMERAS_CHANGES_SUBSCRIBE_FAILED =
  "DEVICES::REMOTE_CAMERAS_CHANGES_SUBSCRIBE_FAILED";

export const REMOTE_CAMERAS_CHANGES_UNSUBSCRIBE =
  "DEVICES::REMOTE_CAMERAS_CHANGES_UNSUBSCRIBE";
export const REMOTE_CAMERAS_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "DEVICES::REMOTE_CAMERAS_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const REMOTE_CAMERAS_CHANGES_UNSUBSCRIBE_FAILED =
  "DEVICES::REMOTE_CAMERAS_CHANGES_UNSUBSCRIBE_FAILED";

export const MICROPHONES_CHANGES_SUBSCRIBE =
  "DEVICES::MICROPHONES_CHANGES_SUBSCRIBE";
export const MICROPHONES_CHANGES_SUBSCRIBE_SUCCEEDED =
  "DEVICES::MICROPHONES_CHANGES_SUBSCRIBE_SUCCEEDED";
export const MICROPHONES_CHANGES_SUBSCRIBE_FAILED =
  "DEVICES::MICROPHONES_CHANGES_SUBSCRIBE_FAILED";

export const MICROPHONES_CHANGES_UNSUBSCRIBE =
  "DEVICES::MICROPHONES_CHANGES_UNSUBSCRIBE";
export const MICROPHONES_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "DEVICES::MICROPHONES_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const MICROPHONES_CHANGES_UNSUBSCRIBE_FAILED =
  "DEVICES::MICROPHONES_CHANGES_UNSUBSCRIBE_FAILED";

export const REMOTE_MICROPHONES_CHANGES_SUBSCRIBE =
  "DEVICES::REMOTE_MICROPHONES_CHANGES_SUBSCRIBE";
export const REMOTE_MICROPHONES_CHANGES_SUBSCRIBE_SUCCEEDED =
  "DEVICES::REMOTE_MICROPHONES_CHANGES_SUBSCRIBE_SUCCEEDED";
export const REMOTE_MICROPHONES_CHANGES_SUBSCRIBE_FAILED =
  "DEVICES::REMOTE_MICROPHONES_CHANGES_SUBSCRIBE_FAILED";

export const REMOTE_MICROPHONES_CHANGES_UNSUBSCRIBE =
  "DEVICES::REMOTE_MICROPHONES_CHANGES_UNSUBSCRIBE";
export const REMOTE_MICROPHONES_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "DEVICES::REMOTE_MICROPHONES_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const REMOTE_MICROPHONES_CHANGES_UNSUBSCRIBE_FAILED =
  "DEVICES::REMOTE_MICROPHONES_CHANGES_UNSUBSCRIBE_FAILED";

export const SPEAKERS_CHANGES_SUBSCRIBE = "DEVICES::SPEAKERS_CHANGES_SUBSCRIBE";
export const SPEAKERS_CHANGES_SUBSCRIBE_SUCCEEDED =
  "DEVICES::SPEAKERS_CHANGES_SUBSCRIBE_SUCCEEDED";
export const SPEAKERS_CHANGES_SUBSCRIBE_FAILED =
  "DEVICES::SPEAKERS_CHANGES_SUBSCRIBE_FAILED";

export const SPEAKERS_CHANGES_UNSUBSCRIBE =
  "DEVICES::SPEAKERS_CHANGES_UNSUBSCRIBE";
export const SPEAKERS_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "DEVICES::SPEAKERS_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const SPEAKERS_CHANGES_UNSUBSCRIBE_FAILED =
  "DEVICES::SPEAKERS_CHANGES_UNSUBSCRIBE_FAILED";

export const REMOTE_SPEAKER_CHANGES_SUBSCRIBE =
  "DEVICES::REMOTE_SPEAKER_CHANGES_SUBSCRIBE";
export const REMOTE_SPEAKER_CHANGES_SUBSCRIBE_SUCCEEDED =
  "DEVICES::REMOTE_SPEAKER_CHANGES_SUBSCRIBE_SUCCEEDED";
export const REMOTE_SPEAKER_CHANGES_SUBSCRIBE_FAILED =
  "DEVICES::REMOTE_SPEAKER_CHANGES_SUBSCRIBE_FAILED";

export const REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE =
  "DEVICES::REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE";
export const REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "DEVICES::REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE_FAILED =
  "DEVICES::REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE_FAILED";

export const SELECT_CAMERA = "DEVICES::SELECT_CAMERA";
export const SELECT_CAMERA_SUCCEEDED = "DEVICES::SELECT_CAMERA_SUCCEEDED";
export const SELECT_CAMERA_FAILED = "DEVICES::SELECT_CAMERA_FAILED";

export const SELECT_MICROPHONE = "DEVICES::SELECT_MICROPHONE";
export const SELECT_MICROPHONE_SUCCEEDED =
  "DEVICES::SELECT_MICROPHONE_SUCCEEDED";
export const SELECT_MICROPHONE_FAILED = "DEVICES::SELECT_MICROPHONE_FAILED";

export const SELECT_SPEAKER = "DEVICES::SELECT_SPEAKER";
export const SELECT_SPEAKER_SUCCEEDED = "DEVICES::SELECT_SPEAKER_SUCCEEDED";
export const SELECT_SPEAKER_FAILED = "DEVICES::SELECT_SPEAKER_FAILED";

export const SELF_VIEW_ADD = "DEVICES::SELF_VIEW_ADD";
export const SELF_VIEW_ADD_SUCCEEDED = "DEVICES::SELF_VIEW_ADD_SUCCEEDED";
export const SELF_VIEW_ADD_FAILED = "DEVICES::SELF_VIEW_ADD_FAILED";

export const SELF_VIEW_REMOVE = "DEVICES::SELF_VIEW_REMOVE";
export const SELF_VIEW_REMOVE_SUCCEEDED = "DEVICES::SELF_VIEW_REMOVE_SUCCEEDED";
export const SELF_VIEW_REMOVE_FAILED = "DEVICES::SELF_VIEW_REMOVE_FAILED";

export const MICROPHONE_SET_MODERATION_STATE =
  "DEVICES::MICROPHONE_SET_MODERATION_STATE";
export const MICROPHONE_RESET_MODERATION_STATE =
  "DEVICES::MICROPHONE_RESET_MODERATION_STATE";
export const CAMERA_SET_MODERATION_STATE =
  "DEVICES::CAMERA_SET_MODERATION_STATE";
export const CAMERA_RESET_MODERATION_STATE =
  "DEVICES::CAMERA_RESET_MODERATION_STATE";
export const CAMERA_SET_HARDWARE_CHECK_STATE =
  "DEVICES::CAMERA_SET_HARDWARE_CHECK_STATE";
export const MICROPHONE_SET_HARDWARE_CHECK_STATE =
  "DEVICES::MICROPHONE_SET_HARDWARE_CHECK_STATE";
export const SPEAKER_SET_HARDWARE_CHECK_STATE =
  "DEVICES::SPEAKER_SET_HARDWARE_CHECK_STATE";
export const DEVICES_RESET_HARDWARE_CHECK_STATE =
  "DEVICES::DEVICES_RESET_HARDWARE_CHECK_STATE";

export const REGISTER_LOCAL_CAMERA_STREAM_INTERCEPTOR =
  "DEVICES::REGISTER_LOCAL_CAMERA_STREAM_INTERCEPTOR";
export const REGISTER_LOCAL_CAMERA_STREAM_INTERCEPTOR_SUCCEEDED =
  "DEVICES::REGISTER_LOCAL_CAMERA_STREAM_INTERCEPTOR_SUCCEEDED";
export const REGISTER_LOCAL_CAMERA_STREAM_INTERCEPTOR_FAILED =
  "DEVICES::REGISTER_LOCAL_CAMERA_STREAM_INTERCEPTOR_FAILED";
